import { BackendRoute } from '../../../config/index';
import { QueryKey } from '../../../constants/index';
import { useAppQuery, useInvalidateQueries } from '../../../hooks/index';
import { ApiService } from '../../../services/index';
import { CompanyIndustry } from '../../../types/company.types';
import { Perk, PerkOfferType } from '../perks.types';

type Props = {
  industryFilter?: CompanyIndustry[];
  offerFilter?: PerkOfferType;
  search?: string;
  skip?: number;
  take?: number;
};

export const usePerks = ({ offerFilter, search, skip, industryFilter, take }: Props = {}) => {
  const { invalidateQuery } = useInvalidateQueries(QueryKey.PERKS, QueryKey.GET);

  const {
    data: { records = [], count = 0, totalPages = 1 } = {},
    isLoading,
    isFetched,
  } = useAppQuery({
    queryKey: [QueryKey.PERKS, QueryKey.GET, { search, take, skip, offerFilter, industryFilter }],
    queryFn: () =>
      ApiService.get<{
        count: number;
        records: Perk[];
        totalPages: number;
      }>(
        {
          endpoint: BackendRoute.PERKS,
        },
        {
          queryParams: {
            search,
            take,
            skip,
            offerFilter,
            industryFilter: industryFilter?.join(','),
          },
        },
      ),
  });

  return {
    invalidateQuery,
    records,
    isLoading,
    totalPages,
    totalRecords: count,
    isFetched,
  };
};
